import { render, staticRenderFns } from "./ProductOptionPreview.vue?vue&type=template&id=1bf19b7c&scoped=true&lang=pug&"
import script from "./ProductOptionPreview.vue?vue&type=script&lang=js&"
export * from "./ProductOptionPreview.vue?vue&type=script&lang=js&"
import style0 from "./ProductOptionPreview.vue?vue&type=style&index=0&id=1bf19b7c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf19b7c",
  null
  
)

export default component.exports